import { types, getRoot, flow } from 'mobx-state-tree';
import Product from './Product';
import axios from 'axios';

export default types.model('SearchStore',
    {
        Products: types.optional(types.array(Product), []),
        SingleProduct: types.maybeNull(Product)

    }).views(self => ({

        //get CurrentCustomerId() {
        //	return getRoot(self).navigation.CurrentCustomerId;
        //},

        get navigation() {
            return getRoot(self).navigation;
        }

    }))
    .actions(self => ({
        afterCreate() {
        },

        setProducts(products) {
            self.Products = products;
        },

        setActiveProduct(sku) {
            self.activeProduct = sku;
            console.debug(self.activeProduct.toJSON());
        },




        async searchProducts(query) {
            console.debug("searchProduct", query);
            self.Products = [];
            const res = await self.request("/Umbraco/Api/Content/SearchProducts", { Query: query, CustomerId: self.navigation.CustomerId, SiteId: self.navigation.SiteId });
            //self.setProducts(res);

            return res;
        },

        async request(path, query = {}) {
            const res = await axios.post(`${path}`, query);
            return res.data;
        }

    }));

